import type { RootfiCompanyUseCase } from '@prisma/client';

/** Whether a RootFi connection row serves a product use case (`useCases` with scalar fallback). */
export function rootFiConnectionServesUseCase(
  row: {
    useCase: RootfiCompanyUseCase | null;
    useCases: RootfiCompanyUseCase[];
  },
  useCase: RootfiCompanyUseCase
): boolean {
  return row.useCases.length > 0
    ? row.useCases.includes(useCase)
    : row.useCase === useCase;
}
